/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-const */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-imports */
import { ValidationErrors, Validators } from '@angular/forms';
import { WorkspaceDatabaseKeys } from '@database/workspace';
import { AppRoutingKeys, fileBooleanMappings } from '@shared';
import { firstValueFrom, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { ValidationKeys } from '../../models';
import { IntervalService } from '../../services/interval.service';
import { IAsyncValidatorHandler } from '../async-validator-handler.interface';
import { CrossTableParams } from '../models/cross-table-params-type';
import { DataRepository } from '@database/workspace';
import { QueryParamsProvider } from '@domain/routing';

export class DupsCheck implements IAsyncValidatorHandler {
	private next: IAsyncValidatorHandler;

	public constructor(
		private intervalService: IntervalService,
		private dataRepository: DataRepository,
		private queryParamsProvider: QueryParamsProvider
	) {}

	public setNext(nextHandler: IAsyncValidatorHandler) {
		this.next = nextHandler;
	}

	public async handle(crossTableParams: CrossTableParams): Promise<ValidationErrors | null> {
		try {
			let holeNumber: string | null = null;
			const projectNumber = crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.projectNumber);

			let dataToCompare: string = crossTableParams.crossControlValue.toString();

			// Fetch the hole_number asynchronously
			try {
				const data = await firstValueFrom(
					this.dataRepository.getTableDataById$(
						'DRILL_HOLE',
						parseInt(this.queryParamsProvider.activeTableId)
					)
				);
				holeNumber = data.hole_number;
			} catch (error) {
				console.error('Error fetching hole_number data:', error);
			}

			// Duplication check based on table metadata and validation rules
			const dupCheck: ValidationErrors | null = await firstValueFrom(
				of(fileBooleanMappings[crossTableParams.tableMetadata[WorkspaceDatabaseKeys.tables.allowDups]]).pipe(
					switchMap((allowDup: boolean) => {
						if (!crossTableParams.skipDupValidation && !allowDup) {
							return this.intervalService
								.isDuplicateData$(
									crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.tableName),
									crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.workfileId),
									crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.projectNumber),
									crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.entityName),
									crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.entryId),
									crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.childEntryId),
									crossTableParams.crossControlKey === WorkspaceDatabaseKeys.columns.depthFrom
										? crossTableParams.crossControlValue
										: crossTableParams.controlValue,
									crossTableParams.crossControlKey === WorkspaceDatabaseKeys.columns.depthTo
										? crossTableParams.crossControlValue
										: crossTableParams.controlValue
								)
								.pipe(
									map((dupFound: boolean) => {
										const appliedValidation: ValidationErrors = dupFound
											? { [ValidationKeys.validationRules.intervalDupRule]: true }
											: null;

										crossTableParams.crossControl.setErrors(appliedValidation);
										return appliedValidation;
									}),
									catchError((error) => {
										console.error('Error in duplication check:', error);
										return of(null);
									})
								);
						}
						return of(null);
					})
				)
			);

			// Additional check for depth validation
			if (crossTableParams.crossControlKey === WorkspaceDatabaseKeys.columns.depth && holeNumber) {
				try {
					const listData = await firstValueFrom(
						this.dataRepository.getTableData$('DRILL_HOLE_DIRECTION', projectNumber)
					);

					const consistData = listData
						.filter((item) => item.hole_number === holeNumber)
						.map((item) => item.depth);

					const isDataDup = consistData.some((item, index) => {
						return item.toString() === dataToCompare;
					});

					if (isDataDup) {
						const error: ValidationErrors = { [ValidationKeys.validationRules.intervalDupRule]: true };
						crossTableParams.crossControl.setErrors(error);
						return error;
					}
				} catch (error) {
					console.error('Error fetching depth data:', error);
				}
			}

			// Return the first found duplication error or pass to the next handler
			if (dupCheck) {
				return dupCheck;
			}

			if (this.next) {
				return await this.next.handle(crossTableParams);
			}

			return null;
		} catch (error) {
			console.error('Unexpected error in DupsCheck handler:', error);
			return null;
		}
	}
}
